var _defineProperty = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/defineProperty.js");
var _slicedToArray = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _classCallCheck = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/createClass.js");
var _possibleConstructorReturn = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/codebuild/output/src4275295061/src/posgrado-ucc/node_modules/@babel/runtime/helpers/inherits.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var YouTube_exports = {};
__export(YouTube_exports, {
  default: function _default() {
    return YouTube;
  }
});
module.exports = __toCommonJS(YouTube_exports);
var import_react = __toESM(require("react"));
var import_utils = require("../utils");
var import_patterns = require("../patterns");
var SDK_URL = "https://www.youtube.com/iframe_api";
var SDK_GLOBAL = "YT";
var SDK_GLOBAL_READY = "onYouTubeIframeAPIReady";
var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
var NOCOOKIE_HOST = "https://www.youtube-nocookie.com";
var YouTube = /*#__PURE__*/function (_import_react$Compone) {
  "use strict";

  function YouTube() {
    var _this;
    _classCallCheck(this, YouTube);
    _this = _callSuper(this, YouTube, arguments);
    __publicField(_this, "callPlayer", import_utils.callPlayer);
    __publicField(_this, "parsePlaylist", function (url) {
      if (url instanceof Array) {
        return {
          listType: "playlist",
          playlist: url.map(_this.getID).join(",")
        };
      }
      if (MATCH_PLAYLIST.test(url)) {
        var _url$match = url.match(MATCH_PLAYLIST),
          _url$match2 = _slicedToArray(_url$match, 2),
          playlistId = _url$match2[1];
        return {
          listType: "playlist",
          list: playlistId.replace(/^UC/, "UU")
        };
      }
      if (MATCH_USER_UPLOADS.test(url)) {
        var _url$match3 = url.match(MATCH_USER_UPLOADS),
          _url$match4 = _slicedToArray(_url$match3, 2),
          username = _url$match4[1];
        return {
          listType: "user_uploads",
          list: username
        };
      }
      return {};
    });
    __publicField(_this, "onStateChange", function (event) {
      var data = event.data;
      var _this$props = _this.props,
        onPlay = _this$props.onPlay,
        onPause = _this$props.onPause,
        onBuffer = _this$props.onBuffer,
        onBufferEnd = _this$props.onBufferEnd,
        onEnded = _this$props.onEnded,
        onReady = _this$props.onReady,
        loop = _this$props.loop,
        _this$props$config = _this$props.config,
        playerVars = _this$props$config.playerVars,
        onUnstarted = _this$props$config.onUnstarted;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
        UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED,
        PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
        PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
        BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
        ENDED = _window$SDK_GLOBAL$Pl.ENDED,
        CUED = _window$SDK_GLOBAL$Pl.CUED;
      if (data === UNSTARTED) onUnstarted();
      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer("getPlaylist");
        if (loop && !isPlaylist) {
          if (playerVars.start) {
            _this.seekTo(playerVars.start);
          } else {
            _this.play();
          }
        }
        onEnded();
      }
      if (data === CUED) onReady();
    });
    __publicField(_this, "mute", function () {
      _this.callPlayer("mute");
    });
    __publicField(_this, "unmute", function () {
      _this.callPlayer("unMute");
    });
    __publicField(_this, "ref", function (container) {
      _this.container = container;
    });
    return _this;
  }
  _inherits(YouTube, _import_react$Compone);
  return _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "getID",
    value: function getID(url) {
      if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
        return null;
      }
      return url.match(import_patterns.MATCH_URL_YOUTUBE)[1];
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;
      var _this$props2 = this.props,
        playing = _this$props2.playing,
        muted = _this$props2.muted,
        playsinline = _this$props2.playsinline,
        controls = _this$props2.controls,
        loop = _this$props2.loop,
        config = _this$props2.config,
        _onError = _this$props2.onError;
      var playerVars = config.playerVars,
        embedOptions = config.embedOptions;
      var id = this.getID(url);
      if (isReady) {
        if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
          this.player.loadPlaylist(this.parsePlaylist(url));
          return;
        }
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, import_utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, import_utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }
      (0, import_utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: "100%",
          height: "100%",
          videoId: id,
          playerVars: _objectSpread(_objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, import_utils.parseStartTime)(url),
            end: (0, import_utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline ? 1 : 0
          }, _this2.parsePlaylist(url)), playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true);
              }
              _this2.props.onReady();
            },
            onPlaybackRateChange: function onPlaybackRateChange(event) {
              return _this2.props.onPlaybackRateChange(event.data);
            },
            onPlaybackQualityChange: function onPlaybackQualityChange(event) {
              return _this2.props.onPlaybackQualityChange(event);
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          },
          host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : void 0
        }, embedOptions));
      }, _onError);
      if (embedOptions.events) {
        console.warn("Using `embedOptions.events` will likely break things. Use ReactPlayer\u2019s callback props instead, eg onReady, onPlay, onPause");
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer("playVideo");
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer("pauseVideo");
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer("getIframe"))) return;
      this.callPlayer("stopVideo");
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      var keepPlaying = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.callPlayer("seekTo", amount);
      if (!keepPlaying && !this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer("setVolume", fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer("setPlaybackRate", rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer("setLoop", loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer("getDuration");
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer("getCurrentTime");
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer("getVideoLoadedFraction") * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: "100%",
        height: "100%",
        display: display
      };
      return /* @__PURE__ */import_react.default.createElement("div", {
        style: style
      }, /* @__PURE__ */import_react.default.createElement("div", {
        ref: this.ref
      }));
    }
  }]);
}(import_react.Component);
__publicField(YouTube, "displayName", "YouTube");
__publicField(YouTube, "canPlay", import_patterns.canPlay.youtube);